import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H3, H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Section = styled.section`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Wrapper = styled.div<{ $gapSize: 'small' | 'large' }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 16px;
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        gap: 24px;
    }

    ${Section} {
        ${({ $gapSize }) => $gapSize === 'small' ? 'gap: 4px;' : 'gap: 8px;'}
    }
`;

export const Item = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    & * {
        :nth-child(3) {
            flex-basis: 100%;
            align-self: flex-start;
        }
    }

    ${H4}, ${H3} {
        width: auto;
        margin: 0;
    }
`;

export const ItemTop = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    justify-content: space-between;
    row-gap: 5px;
`;

export const Separator = styled.hr`
    height: 1px;
    background-color: ${COLORS.Control};
    width: 100%;
    margin: 0;
    border-width: 0;
`;

export const Indentation2SatisfyTheDesignIdea = styled.div`
    display: block;
    height: 12px;
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        height: 16px;
    }
`;
